<template>
    <div class="content listOfExpenses">
    	<div class="head">
    		<div class="organizationName">
    			<h2 v-text="organizationInfo.organizationName">亿量科技内部</h2>
    		</div>
    		<div class="listOfExpensesDesc">
    			<div style="width: 35%;text-align: center;">
    				<p><img src="../../assets/images/money.png" style="width: .32rem;height: .36rem;"></p>
    				<p><span style="color: #fff;font-size: .26rem;">话费余额</span></p>
    				<p>
    					<strong style="font-size: .48rem;">
    						<!-- <font style="font-size: .32rem;">￥</font> -->
    						<font color="#67C23A" v-text="organizationInfo.accountBalance/100" v-if="organizationInfo.accountBalance/100>500">500.00</font>
    						<font color="#FF800B" v-text="organizationInfo.accountBalance/100" v-if="organizationInfo.accountBalance/100<500&&organizationInfo.accountBalance/100>300">500.00</font>
    						<font color="#E6A23C" v-text="organizationInfo.accountBalance/100"v-if="organizationInfo.accountBalance/100<300&&organizationInfo.accountBalance/100>100">300.00</font>
    						<font color="#F56C6C" v-text="organizationInfo.accountBalance/100"v-if="organizationInfo.accountBalance/100<100">100.00</font>
    					</strong>
    				</p>
    				<p>
    					<span style="width:1.44rem;height:.40rem;background:#FF800B;border-radius:.2rem;font-size:.28rem;color: #fff;display: inline-block;line-height: .4rem;" @click="$router.push('/rechargeCallsCost')">充值</span>
    				</p>
    			</div>
    			<em class="line" style="height: 2rem;"></em>
    			<div style="width: 65%;font-size: .26rem;color: #fff;line-height: .4rem;padding-left: .3rem;">
                    <p>
                        <van-row type="flex">
                            <van-col span="16">总充值话费（元）</van-col>
                            <van-col span="8"><strong><font style="font-size: .2rem;">￥</font><font>{{organizationInfo.totalCharge/100}}</font></strong></van-col>
                        </van-row>
                    </p>
                    <p>
                        <van-row type="flex">
                            <van-col span="16">总消耗话费（元）</van-col>
                            <van-col span="8"><font style="font-size: .2rem;">￥</font><font>{{organizationInfo.totalCost/100}}</font></strong></van-col>
                        </van-row>
                    </p>
                    <p>
                        <van-row type="flex">
                            <van-col span="16">总坐席线路月租费（元）</van-col>
                            <van-col span="8"><font style="font-size: .2rem;">￥</font><font>{{organizationInfo.totalMonthlyRent/100}}</font></strong></van-col>
                        </van-row>
                    </p>
    				<!-- <p>
    					<span>智能电话</span>
    					<time>
                            <font v-if="organizationInfo.appLevel==0">未开通</font>
    						<font v-if="organizationInfo.appLevel!=0">{{organizationInfo.appExpireTime}}</font>
    					</time>
    					<span style="width:.88rem;height:.40rem;background:#fff;border-radius:.2rem;font-size:.24rem;color: #3D7EFF;display: inline-block;line-height: .4rem;text-align: center;" @click="$router.push('/rechargeConversation')">续费</span>
    				</p> -->
    				<!-- <p>
    					<span>高效获客</span>
    					<time>
                            <font v-if="organizationInfo.heGetCustomer==0">未开通</font>
    						<font v-if="organizationInfo.heGetCustomer!=0">{{organizationInfo.heGetCustomerExpireTime}}</font>
    					</time>
    					<span style="width:.88rem;height:.40rem;background:#fff;border-radius:.2rem;font-size:.24rem;color: #3D7EFF;display: inline-block;line-height: .4rem;text-align: center;" @click="$router.push('/rechargeHeGetCustomer')">续费</span>
    				</p> -->
    				<!-- <p>
    					<span>管理神器</span>
    					<time>
                            <font v-if="organizationInfo.managementArtifact==0">未开通</font>
    						<font v-if="organizationInfo.managementArtifact!=0">{{organizationInfo.managementArtifactExpireTime}}</font>
    					</time>
    					<span style="width:.88rem;height:.40rem;background:#fff;border-radius:.2rem;font-size:.24rem;color: #3D7EFF;display: inline-block;line-height: .4rem;text-align: center;" @click="$router.push('/rechargeManagementArtifact')">续费</span>
    				</p> -->
    				<!-- <p>
    					<span>电销卫士</span>
    					<time style="width: auto;">购买任意版本即可赠送</time>
    					<span style="width:.88rem;height:.40rem;background:#fff;border-radius:.2rem;font-size:.24rem;color: #3D7EFF;display: inline-block;line-height: .4rem;">续费</span>
    				</p> -->
    			</div>
    		</div>
    	</div>
    	<div class="body">
    		<div class="item">
    			<div class="item-title"><span>缴费记录</span><van-icon name="arrow" @click="$router.push('/rechargeList')"/></div>
    			<div class="item-body">
    				<hr size="2" color="#F6F6F7">
    				<div class="table" style="margin-top: .3rem;">
    					<div class="table-title">
    						<van-row type="flex">
								<van-col span="8">日期</van-col>
								<van-col span="6">充值类型</van-col>
								<van-col span="6">金额</van-col>
								<van-col span="4">状态</van-col>
							</van-row>
    					</div>
    					<div class="table-body">
    						<van-row class="table-null" v-if="list1.length==0">未查询到数据</van-row>
    						<van-row type="flex" class="table-tr" v-for="(item,index) in list1" :key="index">
								<van-col span="8">{{item.rechargeDateStr}}</van-col>
								<van-col span="6">{{trRechargeType(item.rechargeType)}}</van-col>
								<van-col span="6">{{item.money/100}}元</van-col>
								<van-col span="4">{{item.payStatus==2?"已支付":"待支付"}}</van-col>
							</van-row>
    					</div>
    				</div>
    			</div>
    		</div>
    		<div class="item" style="margin-top: .05rem;">
    			<div class="item-title"><span>话费记录</span><van-icon name="arrow" @click="$router.push('/consumptionList')"/></div>
    			<div class="item-body">
    				<hr size="2" color="#F6F6F7">
    				<div class="table" style="margin-top: .3rem;">
    					<div class="table-title">
    						<van-row type="flex">
								<van-col span="8">日期</van-col>
								<van-col span="6">累计消费金额</van-col>
								<van-col span="6">累计通话时长</van-col>
								<van-col span="4">操作</van-col>
							</van-row>
    					</div>
    					<div class="table-body">
							<van-row class="table-null" v-if="list2.length==0">未查询到数据</van-row>
    						<van-row type="flex" class="table-tr" v-for="(item,index) in list2" :key="index">
								<van-col span="8">{{item.recordDate}}</van-col>
								<van-col span="6">{{item.moneyTotal/100}}元</van-col>
								<van-col span="6">{{item.durationTotalStr}}</van-col>
								<van-col span="4"><font color="#02C702" @click="$router.push('/consumptionDesc?time='+item.recordDate)">详情</font></van-col>
							</van-row>
    					</div>
    				</div>
    			</div>
    		</div>
            <div class="item" style="margin-top: .05rem;">
                <div class="item-title"><span>坐席线路月租费记录</span><van-icon name="arrow" @click="$router.push('/seatList')"/></div>
                <div class="item-body">
                    <hr size="2" color="#F6F6F7">
                    <div class="table" style="margin-top: .3rem;">
                        <div class="table-title">
                            <van-row type="flex">
                                <van-col span="8">日期</van-col>
                                <van-col span="8">坐席号</van-col>
                                <van-col span="8">金额</van-col>
                            </van-row>
                        </div>
                        <div class="table-body">
                            <van-row class="table-null" v-if="list3.length==0">未查询到数据</van-row>
                            <van-row type="flex" class="table-tr" v-for="(item,index) in list3" :key="index">
                                <van-col span="8">{{item.createTime}}</van-col>
                                <van-col span="8">{{item.exNumber}}</van-col>
                                <van-col span="8">{{item.money/100}}元</van-col>
                            </van-row>
                        </div>
                    </div>
                </div>
            </div>
    	</div>
    </div>
</template>
<script type="text/javascript">
	import axios from 'axios';
    import {getOrganizationDetail,organizationAccountRecords,consumptionStatisticsList,payList} from '../../api';
    export default {
        name: 'recharge',
        data() {
            return {
                organizationInfo:{
                	accountBalance:0
                },
				list1:[],
				list2:[],
                list3:[]
            }
        },
        methods: {
        	trRechargeType(str){
        		if(str==1){return "话费充值"}
        		if(str==3){return "AI续费"}
        		if(str==9){return "智能电话"}
        		if(str==10){return "高效获客"}
        		if(str==11){return "电销卫士"}
        		if(str==12){return "管理神器"}
        	},
        	getDate(day){
				var setDate = new Date();
				setDate.setTime(setDate.getTime() + 3600 * 1000 * 24 * day);
				return setDate.getFullYear()+"-"+(setDate.getMonth()+1)+"-"+setDate.getDate();
			},
            getOrganizationDetail(){
            	getOrganizationDetail().then((res) => {
                    if(res.code==1){
                        this.organizationInfo = res.data;
                    }else{
                        this.$toast("错误信息:"+res.message);
                    }
                });
            },
            organizationAccountRecords(orderType){
            	organizationAccountRecords({
            		currentPage:1,
            		showCount:5,
            		orderType:orderType
            	}).then((res) => {
                    if(res.code==1){
                        this.list1 = res.data.list;
                    }else{
                        this.$toast("错误信息:"+res.message);
                    }
                });
            },
            consumptionStatisticsList(orderType){
            	consumptionStatisticsList({
					orderType:orderType,
					timeEnd:this.getDate(0),
					timeStart:this.getDate(-4)
            	}).then((res) => {
					if(res.code==1){
						this.list2 = res.data;
					}else{
                        this.$toast("错误信息:"+res.message);
                    }
				})
            },
            // 坐席记录
            searchSeat(){
                payList({
                    timeEnd:this.getDate(0),
                    timeStart:this.getDate(-30),
                    consumptionPurpose: "2",
                    orderType: "2",
                    currentPage: 1,
                    showCount: 5,
                    payType: ""
                }).then((res) => {
                    if(res.code==1){
                        this.list3 = res.data.list;
                    }else{
                        this.$message.error(res.message);
                    }
                })
            }
        },
        mounted(){
        	// this.openId = sessionStorage.getItem('openId');
            this.getOrganizationDetail();
            this.organizationAccountRecords(1);
            this.consumptionStatisticsList(2);
            this.searchSeat();
    	}
	}
</script>
<style type="text/css">
	.listOfExpenses .head {
		background-image: url(../../assets/images/dikuang.png);
		background-size: cover;
		width: 100%;
		height: 4.04rem;
		overflow: hidden;
	}
	.listOfExpenses .head .organizationName h2{
		font-size:.24rem;
		font-family:PingFang SC;
		font-weight: 400;
		color:rgba(255,255,255,1);
		padding: .3rem 0 0 .4rem;
		margin: 0;
	}
	.listOfExpenses .listOfExpensesDesc{
		padding: .2rem 0;
		display: flex;
		justify-content: center;
		align-items: center;
		/*height: 3rem;*/
	}
	.line {
		display: inline-block;
		width: .02rem;
		background-color: #fff;
		opacity: .7;
	}
	.listOfExpenses .listOfExpensesDesc p {
		margin: .15rem 0;
	}
	.listOfExpenses .listOfExpensesDesc time {
		font-size: .24rem;
		margin: 0 .4rem 0 .3rem;
        display: inline-block;
        width: 1.34rem;
	}
	.listOfExpenses .body {
		overflow: hidden;
		width: 7.05rem;
		margin: -.25rem auto 0 auto;
		border-radius:.08rem .08rem 0px 0px;
	}
	.listOfExpenses .item {
		background-color: #fff;
		/*height: 3rem;*/
		padding-top: .3rem;
	}
	.listOfExpenses .item .item-title {
		width: 100%;
		border-left: .1rem solid #3D7EFF;
		font-size: .32rem;
		padding-left: .15rem;
		height: .32rem;
		line-height: .32rem;
		overflow: hidden;
	}
	.listOfExpenses .item .item-title i {
		color: #C3C3C3;
		float: right;
		margin-right: .1rem;
	}
	.listOfExpenses .item .item-body {
		width: 6.68rem;
		margin: auto;
		margin-top: .3rem;
	}
</style>


// WEBPACK FOOTER //
// src/views/order/index.vue


// WEBPACK FOOTER //
// src/views/order/index.vue